/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentProcedureSectionRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/section';

export default AutomationFinAIAgentProcedureSectionRoute;
